import { render, staticRenderFns } from "./CombinePayBtn.vue?vue&type=template&id=10361a9f&scoped=true&"
import script from "./CombinePayBtn.vue?vue&type=script&lang=js&"
export * from "./CombinePayBtn.vue?vue&type=script&lang=js&"
import style0 from "./CombinePayBtn.vue?vue&type=style&index=0&id=10361a9f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10361a9f",
  null
  
)

export default component.exports